/** @format */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {AbsolutePipe} from './absolute.pipe';
import {AvailabilityRateColorPipe} from './availability-rate-colors.pipe';
import {AveragePipe} from './average.pipe';
import {ControlRateColorPipe} from './control-rate-colors.pipe';
import {CountPipe} from './count.pipe';
import {DatePipe} from './date.pipe';
import {FilterPipe} from './filter.pipe';
import {FindPipe} from './find.pipe';
import {GetPipe} from './get.pipe';
import {GreaterThanPipe} from './greater-than.pipe';
import {HeadPipe} from './head.pipe';
import {HumanizeDurationPipe} from './humanize-duration.pipe';
import {IncludesPipe} from './includes.pipe';
import {JoinPipe} from './join.pipe';
import {LastPipe} from './last.pipe';
import {MomentDurationPipe} from './moment-duration.pipe';
import {MomentPipe} from './moment.pipe';
import {NumberMatchPipe} from './number-match.pipe';
import {QualityColorPipe} from './quality-colors.pipe';
import {ReplacePipe} from './replace.pipe';
import {SincePipe} from './since.pipe';
import {SplitPipe} from './split.pipe';
import {StripPipe} from './strip.pipe';
import {ToStringPipe} from './to-string.pipe';
import {UnwindPipe} from './unwind.pipe';

@NgModule({
  declarations: [
    AbsolutePipe,
    NumberMatchPipe,
    GetPipe,
    HeadPipe,
    FindPipe,
    MomentPipe,
    CountPipe,
    FilterPipe,
    MomentDurationPipe,
    HumanizeDurationPipe,
    AveragePipe,
    ToStringPipe,
    SplitPipe,
    UnwindPipe,
    IncludesPipe,
    ReplacePipe,
    StripPipe,
    SincePipe,
    DatePipe,
    LastPipe,
    GreaterThanPipe,
    AvailabilityRateColorPipe,
    ControlRateColorPipe,
    QualityColorPipe,
    JoinPipe,
  ],
  imports: [CommonModule, IonicModule],
  exports: [
    AbsolutePipe,
    NumberMatchPipe,
    GetPipe,
    HeadPipe,
    FindPipe,
    MomentPipe,
    CountPipe,
    FilterPipe,
    MomentDurationPipe,
    HumanizeDurationPipe,
    AveragePipe,
    ToStringPipe,
    SplitPipe,
    UnwindPipe,
    IncludesPipe,
    ReplacePipe,
    StripPipe,
    SincePipe,
    DatePipe,
    LastPipe,
    GreaterThanPipe,
    AvailabilityRateColorPipe,
    ControlRateColorPipe,
    QualityColorPipe,
    JoinPipe,
  ],
})
export class PipesModule {}
